
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/ai/ui/businessTypeInput/businessTypeInput.scss.css.virtualfile';
        module.exports = {"input":"_input_mm0b8_7"};